<ng-contianer *ngIf="showComponent">
  <div class="accelerator-widget p-4 mt-4">
    <h4>{{ 'Lenovo 360 Accelerator' | translate }}</h4>
    <p
      [innerHtml]="
        'Accelerator_bonus_rebate_message'
          | translate
            : {
                programGuide: programGuideUrl
              }
          | safeHtml
      "
      class="my-3"
    ></p>
    <div class="d-flex justify-content-between gap-5">
      <div class="w-50">
        <h5>{{ 'Intelligent Device Group' | translate }}</h5>
        <label class="progress-title"
          >{{ currency?.symbol }}{{ idgProgress?.value?.toFixed(2) | number : '1.2-2' }}</label
        >
        <p
          [innerHtml]="
            isIdgLastBandAchived === false
              ? ('Accelerator sell to achieve target for business group'
                | translate
                  : {
                      currency: currency?.symbol,
                      value: calculateRemainingProgress(idgProgress) | number : '1.2-2',
                      businessGroup: 'IDG'
                    }
                | safeHtml)
              : ('Accelerator achieved target for business group'
                | translate
                  : {
                      businessGroup: 'IDG'
                    })
          "
        ></p>
        <app-progress
          [min]="idgProgress?.min ?? 0"
          [max]="idgProgress?.max ?? 0"
          [progress]="idgProgress?.progress ?? 0"
        ></app-progress>
      </div>
      <div class="w-50">
        <h5>{{ 'Infrastructure Solutions Group' | translate }}</h5>
        <label class="progress-title"
          >{{ currency?.symbol }}{{ isgProgress?.value?.toFixed(2) | number : '1.2-2' }}</label
        >
        <p
          [innerHtml]="
            isIsgLastBandAchived === false
              ? ('Accelerator sell to achieve target for business group'
                | translate
                  : {
                      currency: currency?.symbol,
                      value: calculateRemainingProgress(isgProgress) | number : '1.2-2',
                      businessGroup: 'ISG'
                    }
                | safeHtml)
              : ('Accelerator achieved target for business group'
                | translate
                  : {
                      businessGroup: 'ISG'
                    })
          "
        ></p>
        <app-progress
          [min]="isgProgress?.min ?? 0"
          [max]="isgProgress?.max ?? 0"
          [progress]="isgProgress?.progress ?? 0"
        ></app-progress>
      </div>
    </div>
  </div>
  <div class="bonus-rebate-wrapper" *ngIf="bonusRebate !== null && currency">
    <div class="d-flex align-items-center gap-2 py-1 ps-4">
      <div>{{ 'Bonus rebate' | translate }}:</div>
      <div class="bonus-rebate">{{ currency.symbol }}{{ bonusRebate | number }}</div>
    </div>
  </div>
</ng-contianer>
